module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN337_792756883.dc65b510.png";